<div class="content">
    <h2 class="modal__title">{{ "change_delivery_point.title" | translate }}</h2>
    <div class="modal__content">
        <p class="text">{{ "change_delivery_point.text" | translate }}</p>
        <div class="buttons__container">
            <button
                    class="button"
                    customButton
                    appearance="flat"
                    size="large"
                    (click)="closeModal(true)"
            >
                {{ "change_delivery_point.yes" | translate }}
            </button>

            <button
                    class="button"
                    customButton
                    appearance="ghost"
                    size="large"
                    (click)="closeModal(false)"
            >
                {{ "change_delivery_point.no" | translate }}
            </button>
        </div>
    </div>
</div>